import { Store, createStore } from 'vuex';
import BaseMapStylesModule, { BaseMapStylesState } from "../.././base_map_dialog/store/modules/BaseMapStylesDialogModule";
import LiveLocatorModule, { LiveLocatorState } from "./modules/LiveLocatorModule";
import WaypointDialogModule, {WaypointDialogState} from "../../waypoint_dialog/store/module/WaypointOptionsDialogModule";
import BaseMapDataOverlaysModule, {BaseMapDataOverlaysState} from "../../base_map_dialog/store/modules/./BaseMapDataOverlaysModule";
import BaseMapDataPOIsModule, {BaseMapDataPOIsState} from "../../base_map_dialog/store/modules/BaseMapDataPOIsModule";

export interface RootState {
  liveLocator: LiveLocatorState
  mapStyles: BaseMapStylesState
  waypoints: WaypointDialogState
  mapDataOverlays: BaseMapDataOverlaysState
  mapDataPOIs: BaseMapDataPOIsState
}

const store: Store<RootState> = createStore({
  modules: {
    liveLocator: new LiveLocatorModule(),
    mapStyles: BaseMapStylesModule,
    waypoints: WaypointDialogModule,
    mapDataOverlays: BaseMapDataOverlaysModule,
    mapDataPOIs: BaseMapDataPOIsModule,
  }
})

export default store;
